import React from 'react';
import { FadeIn } from '../ui/BasicUI';

export function Prologue() {
  const scrollDown = () => {
    const el = document.getElementById("chapter-1");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <section className="scene prologue" data-yuga="satya" data-chapter="Prologue">
      <div className="stage center-stack" style={{ gap: "2rem" }}>
        <FadeIn>
          <div className="void-eye">
            <span className="om-monogram">ॐ</span>
          </div>
        </FadeIn>
        <FadeIn delay={400}>
          <p className="sub">Sanatana Chronicles</p>
        </FadeIn>
        <FadeIn delay={900}>
          <p className="open-line">
            Before time, there was sound.<br/>
            Before sound, there was silence.<br/>
            <i style={{ opacity: 0.85 }}>Sit. Listen. The story is older than memory.</i>
          </p>
        </FadeIn>
        <FadeIn delay={1500}>
          <button className="begin-btn" onClick={scrollDown}>Begin the Journey</button>
        </FadeIn>
      </div>
    </section>
  );
}
